import { MouseEvent, useRef } from 'react';
import { PlanLabel } from '@7chairs/types';
import { PickLabelsAnswerBtn, PickLabelsAnswerBox } from './PickLabels.style';
import brownBox from '../../../assets/brownBox.svg';
import CheckedBox from '../../../assets/checkedBox.svg';

interface PickLabelsAnswerButtonProps {
  label: PlanLabel;
  onClick: (label: PlanLabel) => void;
  isSelected: boolean;
}

export const PickLabelsAnswerButton = ({ label, onClick, isSelected }: PickLabelsAnswerButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
    onClick(label);
  };

  return (
    <PickLabelsAnswerBtn
      className={isSelected ? 'selected' : ''}
      id={label.id}
      onClick={handleClick}
      onTouchStart={() => handleClick}
      ref={buttonRef}
    >
      {label.name}
      <PickLabelsAnswerBox src={isSelected ? CheckedBox : brownBox} alt="▢" />
    </PickLabelsAnswerBtn>
  );
};
